import React from 'react'
import {PageServiciosDetalle} from './PageServiciosDetalle'

function PageServicios(props) {
  const displayItems = (props) => {
    if (props) {
      const servicios = props.servicios

      if (servicios) {
        if (servicios.length > 0) {
          return servicios.map((servicio, index) => {
            return (
              <PageServiciosDetalle
                key={index}
                servicio={servicio}
                deleteServicio={props.deleteServicio}
              />
            )
          })
        } else {
          return <h3>No hay servicios</h3>
        }
      } else {
        return <h3>No hay servicios</h3>
      }
    } else {
      return <h3>No hay servicios</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {PageServicios}
